//noScroll
class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function() {
      const $win = $(window);
      const $header = $('.l-header');
      const $btn = $('.js-hum');

    $win.on('load scroll', function() {
      const value = $(this).scrollTop();
      if ( value > 100 ) {
        $header.addClass('is-small');
        $btn.addClass('is-small');
      } else {
        $header.removeClass('is-small');
        $btn.removeClass('is-small');
      }
      });
    });

  }
}
